var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.6668 5.66699H1.3335M1.3335 8.33366H3.69795C4.05807 8.33366 4.23814 8.33366 4.41225 8.3647C4.5668 8.39224 4.71756 8.43789 4.86143 8.5007C5.02352 8.57145 5.17334 8.67134 5.47299 8.8711L5.86067 9.12955C6.16031 9.32932 6.31014 9.4292 6.47223 9.49995C6.6161 9.56276 6.76686 9.60841 6.92141 9.63596C7.09552 9.66699 7.27558 9.66699 7.63571 9.66699H8.36461C8.72474 9.66699 8.9048 9.66699 9.07892 9.63596C9.23347 9.60841 9.38423 9.56276 9.5281 9.49995C9.69019 9.4292 9.84001 9.32932 10.1397 9.12955L10.5273 8.8711C10.827 8.67134 10.9768 8.57145 11.1389 8.5007C11.2828 8.43789 11.4335 8.39224 11.5881 8.3647C11.7622 8.33366 11.9423 8.33366 12.3024 8.33366H14.6668M1.3335 4.80033L1.3335 11.2003C1.3335 11.9471 1.3335 12.3204 1.47882 12.6056C1.60665 12.8565 1.81063 13.0605 2.06151 13.1883C2.34672 13.3337 2.72009 13.3337 3.46683 13.3337L12.5335 13.3337C13.2802 13.3337 13.6536 13.3337 13.9388 13.1883C14.1897 13.0605 14.3937 12.8565 14.5215 12.6056C14.6668 12.3204 14.6668 11.9471 14.6668 11.2003V4.80033C14.6668 4.05359 14.6668 3.68022 14.5215 3.39501C14.3937 3.14412 14.1897 2.94015 13.9388 2.81232C13.6536 2.66699 13.2802 2.66699 12.5335 2.66699L3.46683 2.66699C2.72009 2.66699 2.34672 2.66699 2.06151 2.81232C1.81063 2.94015 1.60665 3.14412 1.47882 3.395C1.3335 3.68022 1.3335 4.05359 1.3335 4.80033Z",
    stroke: "#084836",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletGreen);
export default __webpack_public_path__ + "static/media/wallet-green.58131936ae00f78c6a4e8fc286bc397e.svg";
export { ForwardRef as ReactComponent };